// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1rj-o","savePackageButton":"ClientWallet_savePackageButton__9SGIh"};